import type { IFetcher } from "../../../util/io/Fetcher";
import type {
	GenerateUploadCodeRequestModel,
	GenerateUploadCodeSuccessModel,
	SendUploadCodeViaMailOrSmsAndAddContactDataRequestModel,
	SendUploadCodeViaMailOrSmsAndAddContactDataResponseModel,
} from "../../../../OpenApi/api";
import { isNullOrWhiteSpace } from "../../../util/functions/isNullOrWhiteSpace";

export interface IDicomUploadFetcher {
	generateDicomUploadCode(sourceId: number): Promise<GenerateUploadCodeSuccessModel>;
	sendUploadCodeViaMailOrSMS(uploadCodeId: number, email: string, mobilePhone: string): Promise<SendUploadCodeViaMailOrSmsAndAddContactDataResponseModel>;
}

export class DicomUploadFetcher implements IDicomUploadFetcher {
	constructor(private readonly fetcher: IFetcher) {}

	async generateDicomUploadCode(sourceId: number): Promise<GenerateUploadCodeSuccessModel> {
		const url = "/POW4/upload/GenerateUploadCode";
		const request: GenerateUploadCodeRequestModel = {
			sourceId: sourceId,
		};
		return await this.fetcher.postJSON<GenerateUploadCodeSuccessModel>(url, request);
	}

	async sendUploadCodeViaMailOrSMS(uploadCodeId: number, email: string, mobilePhone: string): Promise<SendUploadCodeViaMailOrSmsAndAddContactDataResponseModel> {
		const url = "/POW4/upload/SendUploadCodeViaMailOrSmsAndAddContactData";
		const request: SendUploadCodeViaMailOrSmsAndAddContactDataRequestModel = {
			uploadCodeId: uploadCodeId,
			email: isNullOrWhiteSpace(email) ? null : email?.trim(),
			mobilePhone: isNullOrWhiteSpace(mobilePhone) ? null : mobilePhone?.trim(),
		};
		return await this.fetcher.postJSON<SendUploadCodeViaMailOrSmsAndAddContactDataResponseModel>(url, request);
	}
}
